import { render, staticRenderFns } from "./RotateLock.vue?vue&type=template&id=05f74ad8&scoped=true&"
import script from "./RotateLock.vue?vue&type=script&lang=ts&"
export * from "./RotateLock.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05f74ad8",
  null
  
)

export default component.exports